
import Banner from "./Banner";


const BaseLayout = () => {
  return (
    <>
      <Banner />
    </>
  );
};

export default BaseLayout;
